import React, { ReactNode } from 'react';

import { Container, Grid, Header, Title } from './DataCard.styled';

interface IProps {
  title?: string;
  headerRight?: ReactNode;
  hideHeaderDivider?: boolean;
  compact?: boolean;
  fullHeight?: boolean;
  children?: ReactNode;
}

export const DataCard = ({
  title,
  headerRight,
  hideHeaderDivider,
  compact,
  fullHeight,
  children,
}: IProps) => {
  return (
    <Container $compact={compact} $fullHeight={fullHeight}>
      {title && (
        <Header $noDivider={hideHeaderDivider}>
          <Title>{title}</Title>
          {headerRight}
        </Header>
      )}
      <Grid>{children}</Grid>
    </Container>
  );
};
